








import Vue from 'vue';
import { formatNumber, formatPercent } from '@/helpers/jsUtils';

export default Vue.extend({
  props: {
    value: {
      type: Number,
      default: 0,
    },
    caret: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    formattedValue(): string {
      if (!this.value) {
        return '-';
      }
      const prefix = this.value > 0 ? '+' : '-';
      const v = formatPercent(Math.abs(this.value));
      if (!this.caret) {
        return `${prefix}${v}`;
      }
      return `${v}`;
    },
    textColor() {
      if (this.value > 0) {
        return 'text-green-600';
      }
      if (this.value < 0) {
        return 'text-brand-red';
      }
      return 'grey';
    },
  },
});
